import { createBrowserRouter, Navigate } from 'react-router-dom';
import AppLayout from '@/components/layout/AppLayout';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import DashboardPage from '@/pages/DashboardPage';
import WorkspacePage from '@/pages/WorkspacePage';
import CanvasPage from '@/pages/CanvasPage';
import ApiTokensPage from '@/pages/ApiTokensPage';
import OAuthClientsPage from '@/pages/OAuthClientsPage';
import OAuthAuthorizePage from '@/pages/OAuthAuthorizePage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: '/dashboard',
            element: <DashboardPage />,
          },
          {
            path: '/workspaces/:workspaceId',
            element: <WorkspacePage />,
          },
          {
            path: '/canvases/:canvasId',
            element: <CanvasPage />,
          },
          {
            path: '/settings/api-tokens',
            element: <ApiTokensPage />,
          },
          {
            path: '/settings/oauth-clients',
            element: <OAuthClientsPage />,
          },
          {
            path: '/oauth/authorize',
            element: <OAuthAuthorizePage />,
          },
        ],
      },
    ],
  },
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
]);

export default router;
